import React, { forwardRef, useState } from 'react';
import classNames from 'classnames';

import styles from './Image.module.scss';
import type { ImageProps } from './Image';

/**
 * VD Private component
 */
const ImageBasic = forwardRef<HTMLImageElement, ImageProps>(({ className, image, alt = '', ...props }, ref) => {
  const [loaded, setLoaded] = useState(false);

  if (!image) return null;

  return (
    <img
      style={{ opacity: loaded ? 1 : 0, transition: 'opacity 0.2s ease-out' }}
      ref={ref}
      className={classNames(className, styles.image)}
      src={image}
      alt={alt}
      onLoad={() => setLoaded(true)}
      {...props}
    />
  );
});

export default React.memo(ImageBasic);
